module.exports = function() {
  return new Worker(__webpack_public_path__ + "be53849b6ba4ad5c31a2.worker.js");
};